//Style
import '../../styles/responsivephone/phone_header.scss'

//Basic
import { useState, useEffect } from 'react'

//Language
import { useLanguage } from '../../context/language_context'

//Images
import NetworkIcon from '../../assets/networkIcon.svg'
import WifiIcon from '../../assets/wifi.svg'
import BatteryIcon from '../../assets/battery.svg'
import MessageIcon from '../../assets/phone_main_msg.svg'
import ParametersIcon from '../../assets/parameters_icon.svg'


function PhoneHeader() {

    const { language } = useLanguage()

    const [currentTime, setCurrentTime] = useState('')
    const [currentDate, setCurrentDate] = useState('')


    useEffect(() => {

        const updateDateAndTime = () => {

            const now = new Date()

            // TIME
            const formattedTime = now.toLocaleTimeString(
                language === 'fr' ? 'fr-FR' : 'en-GB',
                {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                }
            )

            setCurrentTime(formattedTime)


            // DATE
            const formattedDate = now.toLocaleDateString(
                language === 'fr' ? 'fr-FR' : 'en-GB',
                {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long'
                }
            )

            // Capitalize first letter
            setCurrentDate(
                formattedDate.charAt(0).toUpperCase() +
                formattedDate.slice(1)
            )
        }


        // Run immediately
        updateDateAndTime()

        // Then update every second
        const intervalId = setInterval(updateDateAndTime, 1000)


        return () => {
            clearInterval(intervalId)
        }

    }, [language])


    return (

        <section className="overall_phone_header">

            <header className='phone_header'>

                <div className='phone_main_icons_left'>

                    <img
                        src={NetworkIcon}
                        alt=""
                    />

                    <div className='phone_main_messages'>
                        <p>3</p>
                        <img
                            src={MessageIcon}
                            alt=""
                        />
                    </div>

                    <img
                        src={ParametersIcon}
                        alt=""
                        className='parameters_icon'
                    />

                </div>


                <div className='phone_main_icons_right'>

                    <img
                        src={BatteryIcon}
                        alt=""
                    />

                    <img
                        src={WifiIcon}
                        alt=""
                    />

                </div>

            </header>


            <div className='date_and_hour'>

                <p>{currentDate}</p>

                <p className='phone_main_time'>
                    {currentTime}
                </p>

            </div>

        </section>

    )
}


export default PhoneHeader